import React, { useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { List, ListItem, ListItemText } from "@material-ui/core";
import { ChartDataContext } from "../../context/ChartDataContext";
import { Typography } from "@material-ui/core";
import moment from "moment";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import TuneIcon from "@material-ui/icons/Tune";

import "./FeatureList.scss";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "#252A3F",
    borderRadius: "2px",
    color: "#FFF",
    font: "Roboto",
    float: "left",
    marginTop: "10px",
    maxWidth: "35vw",
    opacity: ".9",
    position: "absolute",
    width: "250px",
    zIndex: "1",
    "@media only screen and (max-width: 1000px)": {
      display: "none"
    }
  },
  featureListIcon: {
    color: "#C4C4C4",
    fontSize: "1.2em",
    transform: "rotate(90deg)"
  },
  listItemButton: {
    "&:hover": {
      backgroundColor: "#00081C"
    },
    "&:active": {
      backgroundColor: "#171B26",
      borderLeft: "5px solid #FFC200"
    }
  },
  listItemButtonSelected: {
    borderLeft: "5px solid #FFC200",
    backgroundColor: "#171B26"
  },
  listItemText: {
    fontSize: "15px",
    fontWeight: "700",
    letterSpacing: "1px",
    marginLeft: "10px"
  },
  menu: {
    background: "#293247",
    color: "#FFF",
    width: "150px"
  },
  menuItem: {
    background: "#293247",
    lineHeight: "1"
  },
  menuItemSelected: {
    borderLeft: "5px solid #FFC200",
    backgroundColor: "#171B26"
  },
  nested: {
    paddingLeft: theme.spacing(4)
  }
}));

const FeatureList = () => {
  const classes = useStyles();

  const [featureListAnchorEl, setFeatureListAnchorEl] = useState(false);
  const { setSelectedOverlayData, setTrailTimestamp } = useContext(
    ChartDataContext
  );
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  const handleFeatureListMenuClick = event => {
    setFeatureListAnchorEl(event.currentTarget);
  };

  const handleFeatureListMenuClose = event => {
    setFeatureListAnchorEl(false);
  };

  return (
    <React.Fragment>
      <List
        aria-labelledby="overlays deckgl"
        className={classes.root}
        component="nav"
      >
        <ListItem
          button
          classes={{
            root: classes.listItemButton,
            selected: classes.listItemButtonSelected
          }}
          selected={selectedIndex === 0}
          onClick={event => {
            handleListItemClick(event, 0);
            setSelectedOverlayData({
              selectedDataSource: {
                id: 19,
                name: "Sofar Operational Wave Analysis",
                organization: "Sofar"
              },
              selectedDirectionalVariableId: 7,
              selectedMagnitudeVariableId: 20,
              selectedVariable: {
                id: 20,
                name: "Significant_wave_height_of_combined_wind_waves_and_swell"
              },
              selectedColorScale: [
                { pixelValue: 15.0, red: 124, green: 1, blue: 1, alpha: 200 },
                { pixelValue: 12.5, red: 239, green: 0, blue: 0, alpha: 200 },
                { pixelValue: 10.5, red: 255, green: 80, blue: 0, alpha: 200 },
                { pixelValue: 8.0, red: 255, green: 255, blue: 0, alpha: 200 },
                {
                  pixelValue: 6.0,
                  red: 128,
                  green: 255,
                  blue: 128,
                  alpha: 200
                },
                { pixelValue: 5.0, red: 16, green: 255, blue: 239, alpha: 200 },
                { pixelValue: 3.0, red: 0, green: 159, blue: 255, alpha: 200 },
                { pixelValue: 2.0, red: 0, green: 30, blue: 255, alpha: 200 },
                { pixelValue: 0.0, red: 0, green: 0, blue: 143, alpha: 200 }
              ],
              numberOfPointsOnSide: 90,
              numberOfPointsInPath: 5,
              timeIncrementMinutes: 550
            });
            setTrailTimestamp(moment());
          }}
        >
          <ListItemText
            disableTypography
            primary={
              <Typography variant="subtitle2" className={classes.listItemText}>
                Waves
              </Typography>
            }
          />
        </ListItem>
        <ListItem
          button
          classes={{
            root: classes.listItemButton,
            selected: classes.listItemButtonSelected
          }}
          selected={selectedIndex === 1}
          onClick={event => {
            handleListItemClick(event, 1);
            setSelectedOverlayData({
              selectedDataSource: {
                id: 2,
                name: "NOAA Global Forecast System",
                organization: "NOAA"
              },
              selectedVariable: {
                id: 50,
                name: "Eastward_10_meter_wind_component"
              },
              selectedDirectionalVariableId: 52,
              selectedMagnitudeVariableId: 50,
              numberOfPointsOnSide: 90,
              numberOfPointsInPath: 5,
              timeIncrementMinutes: 50,
              selectedColorScale: [
                { pixelValue: 40, red: 124, green: 1, blue: 1, alpha: 200 },
                { pixelValue: 30, red: 239, green: 0, blue: 0, alpha: 200 },
                { pixelValue: 25, red: 255, green: 80, blue: 0, alpha: 200 },
                { pixelValue: 20, red: 255, green: 255, blue: 0, alpha: 200 },
                { pixelValue: 15, red: 128, green: 255, blue: 128, alpha: 200 },
                { pixelValue: 12, red: 16, green: 255, blue: 239, alpha: 200 },
                { pixelValue: 10, red: 0, green: 159, blue: 255, alpha: 200 },
                { pixelValue: 5, red: 0, green: 30, blue: 255, alpha: 200 },
                { pixelValue: 0, red: 0, green: 0, blue: 143, alpha: 200 }
              ]
            });
            setTrailTimestamp(moment());
          }}
        >
          <ListItemText
            disableTypography
            primary={
              <Typography variant="subtitle2" className={classes.listItemText}>
                Winds
              </Typography>
            }
          />
        </ListItem>
      </List>
      <div className="feature-list-icon-container">
        <TuneIcon
          classes={{ root: classes.featureListIcon }}
          onClick={handleFeatureListMenuClick}
        />
      </div>
      <Menu
        id="feature-list-menu"
        classes={{ paper: classes.menu }}
        anchorEl={featureListAnchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        getContentAnchorEl={null}
        keepMounted
        open={Boolean(featureListAnchorEl)}
        onClose={handleFeatureListMenuClose}
      >
        <MenuItem
          classes={{
            root: classes.menuItem,
            selected: classes.menuItemSelected
          }}
          selected={selectedIndex === 0}
          onClick={event => {
            handleListItemClick(event, 0);
            setSelectedOverlayData({
              selectedDataSource: {
                id: 19,
                name: "Sofar Operational Wave Analysis",
                organization: "Sofar"
              },
              selectedDirectionalVariableId: 7,
              selectedMagnitudeVariableId: 20,
              selectedVariable: {
                id: 20,
                name: "Significant_wave_height_of_combined_wind_waves_and_swell"
              },
              selectedColorScale: [
                { pixelValue: 15.0, red: 124, green: 1, blue: 1, alpha: 200 },
                { pixelValue: 12.5, red: 239, green: 0, blue: 0, alpha: 200 },
                { pixelValue: 10.5, red: 255, green: 80, blue: 0, alpha: 200 },
                { pixelValue: 8.0, red: 255, green: 255, blue: 0, alpha: 200 },
                {
                  pixelValue: 6.0,
                  red: 128,
                  green: 255,
                  blue: 128,
                  alpha: 200
                },
                { pixelValue: 5.0, red: 16, green: 255, blue: 239, alpha: 200 },
                { pixelValue: 3.0, red: 0, green: 159, blue: 255, alpha: 200 },
                { pixelValue: 2.0, red: 0, green: 30, blue: 255, alpha: 200 },
                { pixelValue: 0.0, red: 0, green: 0, blue: 143, alpha: 200 }
              ],
              numberOfPointsOnSide: 90,
              numberOfPointsInPath: 5,
              timeIncrementMinutes: 550
            });
            setTrailTimestamp(moment());
          }}
        >
          Waves
        </MenuItem>
        <MenuItem
          classes={{
            root: classes.menuItem,
            selected: classes.menuItemSelected
          }}
          selected={selectedIndex === 1}
          onClick={event => {
            handleListItemClick(event, 1);
            setSelectedOverlayData({
              selectedDataSource: {
                id: 2,
                name: "NOAA Global Forecast System",
                organization: "NOAA"
              },
              selectedVariable: {
                id: 50,
                name: "Eastward_10_meter_wind_component"
              },
              selectedDirectionalVariableId: 52,
              selectedMagnitudeVariableId: 50,
              numberOfPointsOnSide: 90,
              numberOfPointsInPath: 5,
              timeIncrementMinutes: 50,
              selectedColorScale: [
                { pixelValue: 40, red: 124, green: 1, blue: 1, alpha: 200 },
                { pixelValue: 30, red: 239, green: 0, blue: 0, alpha: 200 },
                { pixelValue: 25, red: 255, green: 80, blue: 0, alpha: 200 },
                { pixelValue: 20, red: 255, green: 255, blue: 0, alpha: 200 },
                { pixelValue: 15, red: 128, green: 255, blue: 128, alpha: 200 },
                { pixelValue: 12, red: 16, green: 255, blue: 239, alpha: 200 },
                { pixelValue: 10, red: 0, green: 159, blue: 255, alpha: 200 },
                { pixelValue: 5, red: 0, green: 30, blue: 255, alpha: 200 },
                { pixelValue: 0, red: 0, green: 0, blue: 143, alpha: 200 }
              ]
            });
            setTrailTimestamp(moment());
          }}
        >
          Wind
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
};

export default FeatureList;
